import { useEffect } from "react";
import { tokenStore } from "@/lib/api";

// Landing point for the central login app: stores the gateway token it put
// in the URL fragment, then does a full load so the app bootstraps signed in.
export default function SsoCallback() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("token");
    if (token) {
      try { sessionStorage.setItem("hv_sso_cb", String(Date.now())); } catch { /* ignore */ }
      tokenStore.set(token);
      window.location.replace("/app");
    } else {
      window.location.replace("/login");
    }
  }, []);
  return null;
}
